import urls from "../urls";
import { callPostApi, callGetApi } from "../callApi";
import objectToQueryString from "@/utils";
const dataService = {
  // getData: (body: FetchDataRequestInterface) => {
  //     return callGetApi(urls.GET_DATA + objectToQueryString(JSON.parse(JSON.stringify(body))))
  // },

  // NOTE:
  // getData2 (v3/trends/stats) and getRTOHeatmap (v3/trends/heatmap)
  // have been moved to server-only helpers (see src/server/trendsServer.ts)
  // so that these APIs are never called from the browser.

  // getRTOHeatmap : (body : {
  //     "pType": string,
  //     "categoryId" ?: number,
  //     "statType" : "ORDER" | "RTO"
  // })=>{
  //     return callPostApi(urls.RTO_HEAT_MAP , body)
  // },

  getGeoGraphicalData: (body: { pType: string; categoryId?: number }) => {
    return callPostApi(urls.GET_GEO_DATA, body);
  },

  getCustomerStats: (body: { mobile: string; pType: string }) => {
    return callGetApi(
      urls.CUSTOMER_STATS +
        objectToQueryString(JSON.parse(JSON.stringify(body))),
    );
  },
};

export default dataService;
